// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { createRouter } from './router'
import { createStore } from './stores/store'
import { sync } from 'vuex-router-sync'
import localforage from 'localforage';
import {localforageConfig} from './common/libs/common.js';

Vue.config.productionTip = false

if (process.browser) {
  const VueTouch = require('vue-touch')
  Vue.use(VueTouch, {name: 'v-touch'})
}


localforage.config(localforageConfig);

/* eslint-disable no-new */
export function createApp () {
  const router = createRouter()
  const  store = createStore()

  sync(store, router)

  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })
  return { app, router, store }
}



// WEBPACK FOOTER //
// ./src/main.js